var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3337 10.0013C18.3337 14.6037 14.6027 18.3346 10.0003 18.3346C5.39795 18.3346 1.66699 14.6037 1.66699 10.0013C1.66699 5.39893 5.39795 1.66797 10.0003 1.66797C14.6027 1.66797 18.3337 5.39893 18.3337 10.0013ZM10.8337 5.83464C10.8337 6.29487 10.4606 6.66797 10.0003 6.66797C9.54009 6.66797 9.16699 6.29487 9.16699 5.83464C9.16699 5.3744 9.54009 5.0013 10.0003 5.0013C10.4606 5.0013 10.8337 5.3744 10.8337 5.83464ZM9.16699 7.70964C8.82182 7.70964 8.54199 7.98946 8.54199 8.33464C8.54199 8.67981 8.82182 8.95964 9.16699 8.95964H9.37533V14.168C9.37533 14.5131 9.65515 14.793 10.0003 14.793C10.3455 14.793 10.6253 14.5131 10.6253 14.168V8.33464C10.6253 7.98946 10.3455 7.70964 10.0003 7.70964H9.16699Z",
    fill: "#00535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFill);
export default __webpack_public_path__ + "static/media/information-fill.a9a8f59d.svg";
export { ForwardRef as ReactComponent };